import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

if (
  document.getElementById('gurado-react') !== null &&
  document.getElementById('gurado-react') !== undefined
) {
  ReactDOM.render(<App />, document.getElementById('gurado-react'));
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
